import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { getData, getFile } from "../../FetchNodeServices";
import { InfinitySpin } from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { addUser, deleteUser } from "../../redux/userSlice";
import AlertMessages from "../Mains/Alerts";

const ManageCustomer = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setfullwidthwrapper] = useState("");
  const [customerList, setCustomerList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [alerts, setAlerts] = useState([]);

  const dispatch = useDispatch();

  const handleToggle = () => {
    setIsActivated(!isActivated);
    setfullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const fetchCustomers = async () => {
    try {
      let result = await getData("users/manage-customer-list");
      setCustomerList(result || []);
      setIsLoading(false);
      dispatch(deleteUser());
      setAlerts([{ variant: "success", heading: "Data fetched successfully." }]);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  useEffect(
    function () {
      if (searchTerm.trim() === "") {
        fetchCustomers();
      }
    },
    [searchTerm]
  );

  // const fillCustomers = () => {
  //   const filteredCustomers = customerList.filter((item) =>
  //     item.accountId.toString().includes(searchTerm)
  //   );
  //   const sortedCustomers = filteredCustomers.sort(
  //     (a, b) => b.userId - a.userId
  //   );

  //   return sortedCustomers.map((item) => (
  //     <tr key={item.userId}>
  //       <td>{item.accountName}</td>
  //       <td>{item.name}</td>
  //       <td>{item.accountId}</td>
  //       <td>{item.subscriptionType}</td>
  //       <td>{item.accountManager}</td>
  //       <td>{item.customerSince}</td>
  //       <td>
  //         <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">
  //           {item.customerStatus === 1 ? "Active" : "Inactive"}
  //         </span>
  //       </td>
  //       <td className="fs-16">
  //         <Link to="/ebasic-detail" onClick={() => dispatch(addUser(item))}>
  //           <i className="bi bi-eye mx-1"></i>
  //         </Link>
  //         <Link to="/setting" onClick={() => dispatch(addUser(item))}>
  //           <i className="bi bi-gear mx-1"></i>
  //         </Link>
  //       </td>
  //     </tr>
  //   ));
  // };
  const fillCustomers = () => {
    const filteredCustomers = customerList.filter((item) => {
      return item.accountId.toString().includes(searchTerm.toLowerCase()) || item.accountName.toLowerCase().includes(searchTerm.toLowerCase());
    });

    const sortedCustomers = filteredCustomers.sort((a, b) => b.userId - a.userId);

    return sortedCustomers.map((item) => (
      <tr key={item.userId}>
        <td>{item.accountName}</td>
        <td>{item.name}</td>
        <td>{item.accountId}</td>
        <td>{item.subscriptionType}</td>
        <td>{item.accountManager}</td>
        <td>{item.customerSince}</td>
        <td>
          <span className="bg-success-subtle text-teal rounded-pill px-2 py-1 fs-12">{item.customerStatus === 1 ? "Active" : "Inactive"}</span>
        </td>
        <td className="fs-16">
          <Link to="/ebasic-detail" onClick={() => dispatch(addUser(item))}>
            <i className="bi bi-eye mx-1"></i>
          </Link>
          <Link to="/setting" onClick={() => dispatch(addUser(item))}>
            <i className="bi bi-gear mx-1"></i>
          </Link>
        </td>
      </tr>
    ));
  };

  const handleExportCsv = async () => {
    try {
      const response = await getFile("users/export-customer-list");
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Customer_Details.csv");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  const handleSearch = () => {
    setIsLoading(true);
    const filteredCustomers = customerList.filter((item) => item.accountId.toString().includes(searchTerm));
    setCustomerList(filteredCustomers);
    setIsLoading(false);
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        <div id="page_wrapper" className="py-3">
          <div className="card p-3 border-light-subtle mb-3">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-people"></i> Customer
              </li>
              <li>
                <span className="breadcrumb_slash">/</span>
                <i className="bi bi-app-indicator mx-2"></i> Manage Customer
              </li>
            </ul>

            <div className="position-absolute top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>

          <div className="card p-3 border-light-subtle">
            <div className="filter_header fs-12 lh-14">
              <div className="row">
                <div className="col-lg-6">
                  <div className="d-flex gap-1">
                    <div className="search_box">
                      <input type="text" value={searchTerm} className="w-100 form-control" onChange={(event) => setSearchTerm(event.target.value)} />
                    </div>
                    <div className="search_button">
                      <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={handleSearch}>
                        <i className="bi bi-search me-1"></i> Filter
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex gap-2 justify-content-end mt-3 mt-lg-0">
                    <button className="btn btn-outline-light border text-dark py-0 fs-12 fw-600" onClick={handleExportCsv}>
                      <i className="bi bi-file-earmark-arrow-down fs-14"></i> Export as CSV
                    </button>
                    <Link to="/basic-detail">
                      <button className="btn btn-success py-0 fs-12 fw-600">
                        <i className="bi bi-plus fs-15"></i> Add new customer
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive mt-3">
              <table className="table fs-14 lh-20">
                <thead className="table-light fs-12 lh-16 border-top">
                  <tr>
                    <th>Account name</th>
                    <th>Name</th>
                    <th>Account ID</th>
                    <th>Subscription Type</th>
                    <th>Account Manager</th>
                    <th>Customer Since</th>
                    <th>Customer Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading && (
                    <tr>
                      <td colSpan={8} className="text-center">
                        <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                      </td>
                    </tr>
                  )}

                  {fillCustomers()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageCustomer;
